<template>
  <div class="prepareLessons">
    <el-tabs v-model="activeName">
      <el-tab-pane label="我的课程" name="first">
        <form-curriculum
          v-if="activeName === 'first'"
          :is_my_class="1"
        ></form-curriculum>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import formCurriculum from './components/form-curriculum'
export default {
  name: 'prepareLessons',
  components: {
    formCurriculum,
  },

  data() {
    return {
      activeName: 'first',
    }
  },
}
</script>

<style scoped lang="scss">
.prepareLessons {
  margin: 10px;
  background: white;
  border-radius: 5px;
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 20px;
}
</style>
